import React, { useState, useEffect } from "react";
import { API_URL } from "../constants";
import { useNavigate } from "react-router-dom";
import axios from 'axios';

export default function ChangePasswordForm({ id, rafraichir, token }) {
  const [newuser, setNewser] = useState({ mail: "", mdp: "" });
  const [messagePassword, setMessagePassword] = useState("");
  const navigate = useNavigate();

  const showMessagePopup = (message) => alert(message);

  const clearMessages = () => {
    setTimeout(() => setMessagePassword(""), 5000);
  };

  useEffect(() => { clearMessages(); }, [messagePassword]);

  const HandleChange2 = (event) => {
    setNewser({ ...newuser, [event.target.name]: event.target.value });
  };

  const handleSubmit3 = (event) => {
    event.preventDefault();
    const userId = id;
    const userMdp = newuser.mdp;

    if (userMdp.length < 8) {
      setMessagePassword("ERREUR : Le mot de passe doit contenir au moins 8 caractères.");
      return;
    }

    axios.patch(
      `${API_URL}/users/${userId}`,
      { password: userMdp },
      { headers: { Accept: "application/json", "Content-Type": "application/json", Authorization: "Bearer " + token } }
    )
      .then(response => {
        if (response.status === 401) {
          showMessagePopup("ERREUR : Votre session a expiré. Veuillez vous reconnecter pour continuer.");
          localStorage.clear();
          navigate.push("/login");
        } else {
          return response.data.data;
        }
      })
      .then(
        () => { setMessagePassword("Mot de passe modifié"); rafraichir(); window.location.reload(); },
        (error) => console.log(error.message)
      );
  };

  const isError = messagePassword && messagePassword !== "Mot de passe modifié";

  return (
    <form onSubmit={handleSubmit3} className="flex flex-col gap-3">
      <input
        className="w-full border border-gray-200 rounded-xl px-4 py-2.5 text-sm bg-gray-50 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-loginBordure/30 focus:border-loginBordure transition"
        onChange={HandleChange2}
        value={newuser.mdp}
        placeholder="Nouveau mot de passe"
        name="mdp"
        type="password"
      />
      <input
        type="submit"
        value="Mettre à jour"
        className="w-full bg-loginBordure hover:bg-blue-900 text-white text-sm font-semibold py-2.5 rounded-xl transition-all duration-200 cursor-pointer border-none"
      />
      {messagePassword && (
        <div className={`flex items-center gap-2 rounded-xl px-3 py-2 text-sm font-medium
          ${isError ? 'bg-red-50 border border-red-200 text-red-700' : 'bg-emerald-50 border border-emerald-200 text-emerald-700'}`}>
          <span className={`w-2 h-2 rounded-full shrink-0 ${isError ? 'bg-red-500' : 'bg-emerald-500'}`} />
          {messagePassword}
        </div>
      )}
    </form>
  );
}